import {ref} from "vue";

export const ENTITY_TYPES = {
  CBP: 'CBP',
  HMO: 'HMO',
  InsuranceCompany: 'Insurance Company',
  PBM: 'PBM',
};

export const ENTITY_STATUSES = {
  Active: 'Active',
  Inactive: 'Inactive',
};

export const NETWORK_STATUSES = {
  Reviewing: 'Reviewing',
  Active: 'Active',
  Inactive: 'Inactive',
};

export const NETWORK_MARKET_TYPE = {
  Individual: 'Individual',
  SmallGroup: 'Small Group',
  Dental: 'Dental',
  PBM: 'PBM',
  TBD: 'TBD',
};

export const ENTITY_LIMIT_HMO = 5;
export const ENTITY_LIMIT_PBM = 10;

export const ATTRIBUTE_TYPES = {
  Document: 'Document Type',
  HceTransaction: 'HCET Transaction Type',
  HceEntity: 'HCET Entity Type',
  HceContactAccess: 'HCET Contact Access',
  HceContactRole: 'HCET Contact Role',
  HceTransactionStatus: 'HCET Transaction Status',
  BusinessUnit: 'Business Unit Type',
  Affiliate: 'Affiliate Type',
  ContactRole: 'Contact Role',
  HpSection: 'HP Section',
};

export const ICONS = {
  InfoCircle: 'pi pi-info-circle',
  EditUser: 'pi pi-user-edit',
  ExclamationTriangle: 'pi pi-exclamation-triangle',
  CheckCircle: 'pi pi-check-circle',
  Edit: 'pi pi-pencil',
  Check: 'pi pi-check',
  Close: 'pi pi-times',
  ErrorCircle: 'pi pi-times-circle',
  View: 'pi pi-external-link',
  User: 'pi pi-user',
  Add: 'pi pi-plus-circle',
  Download: 'pi pi-download',
  Upload: 'pi pi-upload',
  Previous: 'pi pi-chevron-left',
  Next: 'pi pi-chevron-right',
  Trash: 'pi pi-trash',
  Home: 'pi pi-home',
  Attach: 'pi pi-paperclip',
  QuestionCircle: 'pi pi-question-circle',
  Users: 'pi pi-users',
};

export const INPUT_MASKS = {
  Phone: '(999) 999-9999',
  PostalCode: '99999?-9999',
};

export const TOAST_SAVE_LIFE = 5000;

export const ALERT_TYPES = {
  Success: 'success',
  Error: 'error',
  Info: 'info',
  Warning: 'warning',
};

export const EXTERNAL_APPEALS_STATUSES = {
  Open: 'Open',
  InfoNeeded: 'Info Needed',
  Closed: 'Closed',
  ClosedTimelyFiling: 'Closed - Timely Filing',
  ClosedCommerceJurisdiction: 'Closed - Commerce Jurisdiction',
  ClosedDHSJurisdiction: 'Closed - DHS Jurisdiction',
  ClosedCMSJurisdiction: 'Closed - CMS Jurisdiction',
  ClosedUSDOLJurisdiction: 'Closed - U.S. DOL Jurisdiction',
  ClosedFiledAsComplaint: 'Closed - Filed As Complaint',
  ClosedWithdrawn: 'Closed - Withdrawn',
};

export const EXTERNAL_APPEALS_OUTCOMES = {
  Overturned: 'Overturned',
  PartiallyOverturned: 'Partially Overturned',
  Upheld: 'Upheld',
  Pending: 'Pending',
  WithdrawnEnrollee: 'Withdrawn - Enrollee',
  WithdrawnInsuranceReversedDecision: 'Withdrawn - Insurance Reversed Decision',
  NotApplicable: 'Not Applicable',
};

export const EXTERNAL_APPEALS_REVIEW_ORGANIZATIONS = {
  RoffeHHC: 'Roffe HHC',
  MMROCorevisory: 'MMRO Corevisory',
  MichiganPeerReview: 'Michigan Peer Review (iMPROve)',
};

export const EXTERNAL_APPEALS_CATEGORIES = {
  ClaimCoverage: 'Claim Coverage',
  PriorAuthorization: 'Prior Authorization',
  PharmacyCoverage: 'Pharmacy Coverage',
  WeightLoss: 'Weight Loss',
  OutOfNetwork: 'Out-of-Network Provider',
  Intracept: 'Intracept',
  PreventativeServices: 'Preventative Services',
};

export const EXTERNAL_APPEALS_PATIENT_RELATIONSHIPS = {
  Self: 'Self',
  Spouse: 'Spouse',
  Parent: 'Parent',
  Guardian: 'Guardian',
  HealthCareProvider: 'Health Care Provider',
  Other: 'Other',
};

export const EXTERNAL_APPEALS_HEALTH_INSURANCE_COMPANIES = {
  AllinaHealthAetna: 'Allina Health & Aetna Health Plan',
  BlueCrossBlueShield: 'Blue Cross & Blue Shield/Blue Plus',
  HealthPartners: 'HealthPartners',
  HennepinHealth: 'Hennepin Health',
  HumanaWI: 'Humana of WI',
  ItascaMedicalCare: 'Itasca Medical Care',
  Medica: 'Medica Health Plan',
  PrimeWest: 'PrimeWest',
  Quartz: 'Quartz',
  SanfordMN: 'Sanford Health Plan of MN',
  SouthCountry: 'South Country Health Alliance',
  UCare: 'UCare',
  UnitedHealthcareIL: 'United HealthCare of IL',
  Other: 'Other',
};

export const EXTERNAL_APPEALS_TYPE_OF_COVERAGES = {
  Group: 'Group (Employer) Coverage',
  Individual: 'Individual (MNSure)',
  PMAP: 'PMAP/Medical Assistance',
  MinnesotaCare: 'MinnesotaCare',
  Medicare: 'Medicare',
  Other: 'Other',
};

export const EXTERNAL_APPEALS_INTERNAL_APPEAL_CONFIRMATION_OPTIONS = {
  Filed: 'I have filed an appeal with my HMO',
  NotFiled: 'I have NOT filed an appeal with my HMO',
  DontKnow: 'I don\'t know',
};

export const CONSUMER_COMPLAINT_PATIENT_RELATIONSHIPS = {
  Self: 'Self',
  Spouse: 'Spouse',
  Parent: 'Parent',
  Guardian: 'Guardian',
  HealthCareProvider: 'Health Care Provider',
  Other: 'Other',
};

export const CONSUMER_COMPLAINT_HEALTH_INSURANCE_COMPANIES = {
  AllinaHealthAetna: 'Allina Health & Aetna Health Plan',
  BlueCrossBlueShield: 'Blue Cross & Blue Shield/Blue Plus',
  HealthPartners: 'HealthPartners',
  HennepinHealth: 'Hennepin Health',
  HumanaWI: 'Humana of WI',
  ItascaMedicalCare: 'Itasca Medical Care',
  Medica: 'Medica Health Plan',
  PrimeWest: 'PrimeWest',
  Quartz: 'Quartz',
  SanfordMN: 'Sanford Health Plan of MN',
  SouthCountry: 'South Country Health Alliance',
  UCare: 'UCare',
  UnitedHealthcareIL: 'United HealthCare of IL',
  Other: 'Other',
};

export const CONSUMER_COMPLAINT_TYPE_OF_COVERAGES = {
  Group: 'Group (Employer) Coverage',
  Individual: 'Individual (MNSure)',
  PMAP: 'PMAP/Medical Assistance',
  MinnesotaCare: 'MinnesotaCare',
  Medicare: 'Medicare',
  Other: 'Other',
};

export const CONSUMER_COMPLAINT_STATUSES = {
  Default: 'Pending Information Insurance',
  Open: 'Open',
  PendingInformationInsurance: 'Pending Information Insurance',
  PendingInformationProvider: 'Pending Information Provider',
  PendingInformationIndividual: 'Pending Information Individual',
  Closed: 'Closed',
  Withdrawn: 'Withdrawn',
};

export const CONSUMER_COMPLAINT_OUTCOMES = {
  ResolvedNoFault: 'Resolved - No Fault',
  ResolvedMutualAgreement: 'Resolved - Mutual Agreement',
  ResolvedWithdrawn: 'Resolved - Withdrawn',
  ReferredToDHS: 'Resolved to DHS',
  ReferredToCommerce: 'Resolved to Commerce',
  ReferredToMMB: 'Resolved to MMB',
  ReferredToCMS: 'Resolved to CMS',
  EnforcementNeed: 'Enforcement needed- forward to supervisor',
  ReferredOther: 'Resolved Other',
  DateOfInformationInsurance: 'Date of Information due from Insurance (Manual entry)',
  DateOfInformationProvider: 'Date of Information due from Provider (Manual entry)',
};

export const CONSUMER_COMPLAINT_CATEGORIES = {
  ClaimCoverage: 'Claim Coverage',
  BalanceBilling: 'Balance Billing',
  NoSurprisesAct: 'No Surprises Act',
  MentalHealthParity: 'Mental Health Parity',
  NetworkAdequacy: 'Network Adequacy',
  QualityOfCare: 'Quality of Care',
  Enrollment: 'Enrollment',
  ProviderQuality: 'Provider Quality',
  Undetermined: 'Undetermined',
  PharmacyBenefits: 'Pharmacy Benefits',
  CsInsurance: 'CS - Insurance',
  CsProvider: 'CS - Provider',
};

export const CONSUMER_COMPLAINT_MDH_INVESTIGATORS = {
  EcklundAndrea: 'Ecklund, Andrea',
  PetersonKirsten: 'Peterson, Kirsten'
};

export const HMO_CDP_UPDATE_DOCUMENTS = {
   Incorporation:"Articles of Incorporation",
   Bylaws:"Bylaws",
   Conflict:"Conflict of Interest Policy",
   Provider:"Provider contracts",
   Complaint:"Internal complaint and appeal procedures",
   Authorization:"Prior Authorization Procedures",
   Agreements:"Agreements with other insurer",
   Enrollee:"Enrollee participation mechanism",
   Financial:"Marketing and Financial plan",
   Administrative:"Administrative Services Agreements/Management Agreements",
   Cybersecurity:" Cybersecurity Event Reporting",
   HMOPlans:"HMO Collaboration Plans",
   Other: 'Other'
};

export const ACCEPTED_FILE_TYPES = {
  Pdf:'application/pdf',
  Xlsx:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  Xlsm:'application/vnd.ms-excel.sheet.macroenabled.12',
  Docx:'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  Xls:'application/vnd.ms-excel',
  Doc:'application/msword',
  Jpeg:'image/jpeg',
  Png:'image/png',
};

export const EXTERNAL_APPEALS_FORWARD_AUTHORIZATION_OPTIONS = {
  Authorized: 'I authorize MDH to forward my external appeal to the appropriate state agency.',
  NotAuthorized: 'I DO NOT authorize MDH to forward my external appeal to the appropriate state agency.',
};

export const CONSUMER_COMPLAINT_TYPES = {
  InsuranceClaimError: "My insurance company incorrectly processed my claim",
  PrescriptionDenied: "My prescription drug was denied",
  PriorAuthDenied: "My prior authorization for a procedure or service was denied",
  ProviderOutOfNetwork: "My provider was out-of-network",
  CoverageTerminated: "My coverage was terminated",
  PreventiveServiceBilling: "I am being billed for a preventive service",
  NoSurprisesAct: "My complaint is related to the No Surprises Act",
  BalanceBilling: "I am being balance billed by my provider",
  QualityOfCare: "My complaint is about the quality of care I've received from my provider",
  SomethingElse: "Something else",
};

export const NOTE_TYPES = {
    Document: 'document',
    Appeal: 'appeal',
    Complaint: 'complaint',
};

export const NOTE_MAX_LENGTH = 240;

// Helper function for Form Select/Options lists.
export const getAsFormOptions = (c) => {
  return Object.entries(c).map(([key, value]) => ({
    label: value,
    value: key,
  }));
};
